module.exports = __webpack_public_path__ + "static/img/9.d896f83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carrossel/web/9.jpg
// module id = 6iQw
// module chunks = 4